import Avatar from '@material-ui/core/Avatar';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriConsultantInfo'
};

const styles = theme => ({
  root: {
    display: 'grid',
    height: 85,
    alignItems: 'center',
    gridColumnGap: theme.spacing(4),
    gridTemplateColumns: 'auto auto 1fr',
    gridTemplateRows: '1fr 1fr 1fr',
    gridTemplateAreas: `
        'profile-picture consultant-name consultant-name'
        'profile-picture consultant-title consultant-title'
        'profile-picture consultant-number consultant-number'
        `
  },
  profilePicture: {
    gridArea: 'profile-picture',
    width: 85,
    height: 85
  },
  customerInitials: {
    gridArea: 'profile-picture',
    width: 85,
    height: 85,
    backgroundColor: theme.palette.background.chatelle,
    fontSize: theme.spacing(6),
    fontWeight: 'bold'
  },
  consultantName: {
    gridArea: 'consultant-name'
  },
  consultantTitle: {
    gridArea: 'consultant-title'
  },
  consultantNumber: {
    gridArea: 'consultant-number',
    color: theme.palette.text.disabled
  }
});

export const ConsultantInfo = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    classes,
    profilePictureUrl,
    consultantInitials,
    consultantName,
    consultantTitle,
    consultantNumber,
    className
  } = props;
  const image = useMemo(() => {
    if (profilePictureUrl) {
      return /*#__PURE__*/_jsx(Avatar, {
        className: classes == null ? void 0 : classes.profilePicture,
        alt: "",
        src: profilePictureUrl
      });
    }

    return /*#__PURE__*/_jsx(Avatar, {
      className: classes == null ? void 0 : classes.customerInitials,
      children: consultantInitials
    });
  }, [profilePictureUrl, consultantInitials, classes]);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: clsx(classes.root, className),
    children: [image, /*#__PURE__*/_jsx(Typography, {
      noWrap: true,
      className: classes.consultantName,
      variant: "h6",
      gutterBottom: false,
      children: consultantName
    }), /*#__PURE__*/_jsx(Typography, {
      className: classes.consultantTitle,
      children: consultantTitle
    }), /*#__PURE__*/_jsx(Typography, {
      className: classes.consultantNumber,
      children: consultantNumber
    })]
  });
});
export default withStyles(styles, componentConfig)(ConsultantInfo);